/** Spurt does not sign anyone in. The suite already does: its auth context holds the logged-in user and their token, and
 *  <SpurtHost> hands that token to this module. Everything else (REST, the realtime socket, push registration) asks here. */

let current = "";
let rejected: (() => void) | undefined;

/** Called by <SpurtHost> whenever the suite's token changes (sign-in, refresh, sign-out = empty). */
export const setSessionToken = (token: string | null | undefined): void => {
  current = token ?? "";
};

/** The suite's token for the signed-in user, or null when nobody is signed in. */
export const getToken = (): string | null => (current ? current : null);

/** Optional: be told when the Spurt service refuses the token (HTTP 401). Spurt never signs the user out of the suite
 *  itself: a refused token shows a message in the chat instead. */
export const onSessionRejected = (fn: (() => void) | undefined): void => {
  rejected = fn;
};

export const sessionRejected = (): void => rejected?.();
